import QuillEditorViewOnly from "@components/QuillEditor/QuillEditorViewOnly";
import { EnumJobStatus2 } from "@utils/constants";
import {
  Building2,
  ChartNoAxesCombined,
  CreditCard,
  FileText,
  Gift,
  Laptop,
  MapPin,
} from "lucide-react";

const JobDescription = ({ data }) => {
  const facts = [
    {
      label: "Location",
      value: data?.location,
      icon: <MapPin size={14} />,
    },
    {
      label: "Industry",
      value: data?.industryType || "N/A",
      icon: <Building2 size={14} />,
    },
    {
      label: "Contract type",
      value: data?.jobTypes ? EnumJobStatus2[data?.jobType] : "N/A",
      icon: <FileText size={14} />,
    },
    {
      label: "Salary",
      value: `${data?.salary?.min} - ${data?.salary?.max}`,
      icon: <CreditCard size={14} />,
    },
    {
      label: "Benefits",
      value: "Pension and flexible working",
      icon: <Gift size={14} />,
    },
    {
      label: "Work style",
      value: "N/A",
      icon: <Laptop size={14} />,
    },
    {
      label: "Seniority level",
      value: data?.positionLevel,
      icon: <ChartNoAxesCombined size={14} />,
    },
  ];

  return (
    <div className="flex min-h-0 flex-1 overflow-y-scroll no-scrollbar">
      <div className="flex flex-col flex-1">
        <div className="flex flex-col border-l-2 border-l-slate-600 border-b pl-3 pb-3 gap-0.5">
          <span className="text-content-muted text-xss font-bold uppercase tracking-widest">
            Hiring Company
          </span>
          <span className="text-content-muted font-bold text-sm">
            Company not disclosed
          </span>
        </div>
        <QuillEditorViewOnly value={data?.description} />
      </div>
      <div className="flex flex-col w-[24%] border-l pl-4 ml-4 gap-4">
        <span className="font-bold text-sm text-content-muted">Job facts</span>
        <div className="flex flex-col gap-6">
          {facts?.map((fact) => {
            return (
              <div className="flex gap-2">
                <div className="w-8 h-8 rounded-md flex items-center justify-center border text-light-black shrink-0">
                  {fact?.icon}
                </div>
                <div className="flex flex-col">
                  <span className="text-slate-800 font-bold text-xss">
                    {fact?.label}
                  </span>
                  <span className="text-xs font-medium text-light-black">
                    {fact?.value}
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default JobDescription;
